import * as React from 'react';
import Modal from "react-responsive-modal";
import {useState} from "react";
import Icons from "../../Icons";
import ReactTooltip from "react-tooltip";
import {EditorMenu} from "./EditorMenu";
import {cmjnData} from "./UpdateCmjn";
import {getShopRefInStorage} from "../../MonCompteAction";

interface ThumbnailUploadBtnActionsProps {
  onDeleteFile: any;
  data: any;
  modificationsEnabled: boolean;
  canViewFeatures: boolean;
  changeOptionEvent: any;
  resetCustomOptions: any;
  handleChangeColors: any;
  submitHandleChangeColors: any;
  getPreview: any;
  updateDimensions: any;
  onDownloadFile: any;
  onChangeOutlineProcessing: any;
  onlyDownload: boolean;
  nonConforme: boolean;
  onApplyOutline: (applyOutline: boolean, colorOutline: string) => void;
  onRollback: () => void;
  onCheckImageUsage: () => Promise<boolean>;
  onUpdateCmjn?: (idCaddies: string, cmjnData: cmjnData) => void;
  canUpdateCmjn: boolean;
  canUpdateOutlineProcessing: boolean;
  activateCheckImageUsage: boolean;
  canCheckImageUsage: boolean;
  canDownloadEmbroidery: boolean;
}

export const ThumbnailUploadBtnActions = (props: ThumbnailUploadBtnActionsProps) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [showResize, setShowResize] = useState(false);
  const [isCopyrightFree, setCopyrightFree] = useState<boolean | null>(props.data.originalFileInfos.copyrightInfos?.pass == "1");
  const colorCopyright = isCopyrightFree ? "green" : "red";
  const passIsEmpty = props.data.originalFileInfos.copyrightInfos?.pass === null || props.data.originalFileInfos.copyrightInfos?.pass === undefined;
  const [imageUsageColor, setImageUsageColor] = useState<string>(passIsEmpty ? "black" : colorCopyright);
  const [loading, setLoading] = useState<boolean>(false);
  const [tooltipInfos, setTooltipInfos] = useState<string>(props.data.originalFileInfos.copyrightInfos?.message ?? "Vérifier les droits d'auteur");

  const renderDeleteModal = () => {
    return (
      <Modal open={openDelete} onClose={() => setOpenDelete(!openDelete)} center
             classNames={{overlay: 'bootstrap-container', modal: 'deleteFileModalContainer customModal',
               closeButton: 'deleteFileModalCloseButton closeButton'}}>
        <div className="p-2">
          <p className="text-center font18 bold">&Ecirc;tes-vous sûr de vouloir supprimer ce fichier ?</p>

          <button title="Annuler" onClick={() => setOpenDelete(!openDelete)}
                  className="border-0 bold bg-white cursor-pointer border-dark btnCancelModal float-left py-2 px-3">
            Non
          </button>
          <button title="Supprimer le fichier" onClick={(e) => props.onDeleteFile(e)}
                  className="border-dark border bold bg-white cursor-pointer btnValidateModal float-right py-2 px-3">
            Oui
          </button>
        </div>
      </Modal>
    );
  };

  const checkImageUsage = () => {
    if(!loading) {
      setLoading(true);
      props.onCheckImageUsage().then((result: {canBeUsed: boolean, message: string, success: boolean}) => {
        setImageUsageColor(result.canBeUsed ? "green" : "red");
        setTooltipInfos(result.message);
        setCopyrightFree(result.canBeUsed);
        setLoading(false);
      });
    }
  }

  return (
    <div className={'d-flex flex-column position-relative '}>
      <div className={'h-100 d-flex flex-column justify-content-end'}>
        {(props.modificationsEnabled || props.onlyDownload) &&
          <>
            {props.data.isInternalUser && !props.data.customerView && props.data.activateCheckImageUsage && props.data.order.confirmationFichier == "1" && props.data.order.validation_bat == "2" && props.data.canCheckImageUsage && <>
              <a data-tip={tooltipInfos} data-for={props.data.identifier + 'copyright'} onClick= {checkImageUsage}
                className={`batAutoBtnEditor mb-3 ${loading ? 'loading-spin' : ''}`}>
                {loading ? <Icons icon="ic-loading" size={32}/> : <Icons icon="ic-copyright" size={32} color={imageUsageColor}/>}
              </a>
              <ReactTooltip type="dark" effect="solid"  id={props.data.identifier+'copyright'}  place="right" />
            </>}
            {props.data.order.confirmationFichier == 0  &&
              <>
                <a data-tip='Supprimer le visuel' data-for={props.data.identifier + 'del'} onClick= {() => setOpenDelete(true)}
                   className={`batAutoBtnEditor batAutoBtnEditorDelete mb-3`}>
                  <Icons icon="ic-trash" size={20} color="black"/>
                </a>
                {renderDeleteModal()}
                <ReactTooltip   type="dark" effect="solid"  id={props.data.identifier+'del'}  place="right"  />
              </>
            }
            { (props.canViewFeatures || props.onlyDownload) && !props.nonConforme && props.data.originalFileInfos?.quality?.quality !== 'bad' && ((props.data.isInternalUser && !props.data.customerView && getShopRefInStorage() === 'DT') || getShopRefInStorage() !== 'DT') &&
              <>
                <a data-tip='Outils' data-for={props.data.identifier + 'menuOutils'} data-event={'click'}
                   data-scroll-hide='false' className={`batAutoBtnEditor batAutoBtnEditorTools`}>
                  <Icons data-tip='Outils' data-for={props.data.identifier + 'outils'} icon="ic-editor" size={25}
                         color="black"/>
                </a>
                <ReactTooltip   type="dark"  id={props.data.identifier+'outils'}  className="ml-3" effect="solid"  place="right" />
                <ReactTooltip
                  afterHide={() => setShowResize(false)}
                  borderColor='grey'
                  type="light"
                  border
                  clickable
                  id={props.data.identifier+'menuOutils'}
                  className="react-tooltip-clickable-link shadow ml-4 menuOutils"
                  globalEventOff='click'
                  place="right"
                  getContent={() => (
                    <EditorMenu
                      onChangeOutlineProcessing={props.onChangeOutlineProcessing}
                      showResize={showResize}
                      changeOptionEvent={props.changeOptionEvent}
                      resetCustomOptions={props.resetCustomOptions}
                      handleChangeColors={props.handleChangeColors}
                      submitHandleChangeColors={props.submitHandleChangeColors}
                      getPreview={props.getPreview}
                      onDownloadFile={props.onDownloadFile}
                      onlyDownload={props.onlyDownload}
                      updateDimensions={props.updateDimensions}
                      data={props.data}
                      onRollback={props.onRollback}
                      onUpdateCmjn={props.onUpdateCmjn}
                      canUpdateCmjn={props.canUpdateCmjn}
                      canDownloadEmbroidery={props.canDownloadEmbroidery}
                      canUpdateOutlineProcessing={props.canUpdateOutlineProcessing}
                      onApplyOutline={props.onApplyOutline}
                    />
                  )}
                />
              </>
            }
          </>
        }
      </div>
    </div>
  );
}